/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import SubaccountHeader from 'app/components/Headers/SubaccountHeader.jsx';
import Toggle from 'app/components/common/ToggleControl.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import FilterMixin from 'app/mixins/FilterMixin.js';
import UserMessages from 'app/modules/UserMessageModule.js';
import SubscriptionModule from 'app/mixins/SubscriptionModule.js';
import classnames from 'classnames';
import * as _ from 'underscore';
import { FormattedDate } from 'react-intl';
import DeleteModal from 'app/components/common/DeleteModal.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import { compose } from 'redux';
import SubaccountProvider from 'app/redux/Providers/SubaccountProvider.jsx';
import Utilities from 'app/utility/Utilities.js';
import { Breakpoint } from 'react-socks';
import FeatureUpgradeComponent from 'app/components/Subscription/FeatureUpgradeComponent.jsx';
import { Link } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import makeToast from 'app/modules/makeToast.js';

const newBoilerplate = `Hi-

Please connect your social media profiles to dlvr.it so we'll be able to post on your behalf.

It's simple, you'll first create a dlvr.it log in and then connect your social media pages and profiles to dlvr.it.

After that, we'll manage posting to your social media pages and profiles.`;

const resendBoilerplate = `Hi-

Just a friendly reminder to connect your social media profiles to dlvr.it so we'll be able to post on your behalf.

It's simple, you'll first create a dlvr.it log in and then connect your social media pages and profiles to dlvr.it.

After that, we'll manage posting to your social media pages and profiles.`;

/**
 * Whether the clients can be listed: by the account owner, on a plan with clients. On a fresh load
 * the plan's seats arrive after the page mounts, so this is asked again as they come in.
 */
function canListClients(props) {
    let seats = parseInt(props.user.perms.perms.clientSeats, 10);

    return props.app.userLoaded && props.user.detail.isAgent === false && !isNaN(seats) && seats !== 0;

}

class Clients extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            detailId: 0,
            // Pending invitations are selected by address: they have no Publisher row,
            // so their id is 0 — which detailId already spends on "nothing selected".
            pendingEmail: '',
            // the note that goes out with a resent invitation, seeded from the invite
            pendingMessage: '',
            showPendingMessage: false,
            subaccount: {},
            newSubaccount: {},
            errors: null,
            updateMessages: [],
            lastUpdate: '',
            showMessageField: false
        };

        this._getSubaccounts = this._getSubaccounts.bind(this);
        this.createNewSubaccount = this.createNewSubaccount.bind(this);
        this.cancel = this.cancel.bind(this);
        this.detailHandler = this.detailHandler.bind(this);
        this.pendingDetailHandler = this.pendingDetailHandler.bind(this);
        this.togglePendingMessage = this.togglePendingMessage.bind(this);
        this.updatePendingMessage = this.updatePendingMessage.bind(this);
        this.resendInvite = this.resendInvite.bind(this);
        this.revokeInvite = this.revokeInvite.bind(this);
        this.updateSubaccount = this.updateSubaccount.bind(this);
        this.updateSubaccountFields = this.updateSubaccountFields.bind(this);
        this.setSubaccountActiveState = this.setSubaccountActiveState.bind(this);
        this.saveSubaccount = this.saveSubaccount.bind(this);
        this.deleteSubaccount = this.deleteSubaccount.bind(this);
        this.searchUsers = this.searchUsers.bind(this);
        this.toggleMessageField = this.toggleMessageField.bind(this);
        this.onAddClientClick = this.onAddClientClick.bind(this);

    }


    _getSubaccounts() {

        if (!_.isEmpty(this.props.subaccounts.filter)) {
            return this.props.subaccounts.filteredList;
        }

        return  this.props.subaccounts.list;

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            errors = null;

        errors = props.getApiErrors(['SUBACCOUNT_LIST', 'SUBACCOUNT_UPDATE', 'SUBACCOUNT_CREATE', 'SUBACCOUNT_DETACH']);
        if (state.errors === null && errors.length) {
            nextState.errors = errors[0];
        } else if (state.errors !== null && errors.length === 0) {
            nextState.errors = null;
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {
        let id = parseInt(this.props.router.params.subaccountId, 10),
            constants = this.props.app.config.constants;

        // clean up errors from Users if present
        this.props.deleteApiError(['SUBACCOUNT_LIST', 'SUBACCOUNT_UPDATE', 'SUBACCOUNT_CREATE', 'SUBACCOUNT_DETACH']);

        if (canListClients(this.props)) {
            this.props.getSubaccounts({
                accountType: constants.SUB_CLIENT
            });
        }

        if (this.props.app.firstLoad.SOCIAL_LIST === false) {
            this.props.getSocials();
        }

        if (id) {
            this.setState({
                detailId: id
            });
        }

        // just a little initialization
        this.props.clearFilter('subaccounts');

    }

    componentDidUpdate(prevProps, prevState) {
        let constants = this.props.app.config.constants;

        if (!canListClients(prevProps) && canListClients(this.props)) {
            this.props.getSubaccounts({
                accountType: constants.SUB_CLIENT
            });
        }

        // show the interface for creating new users
        if (prevProps.app.loading.SUBACCOUNT_LIST === true && this.props.app.loading.SUBACCOUNT_LIST === false) {
            if (this.props.subaccounts.list.length === 0 && this.props.router.location.pathname.match('new') === null) {
                this.props.router.navigate('/people/clients/new');
            }
            if (this.state.detailId !== 0 && _.isEmpty(this.state.subaccount)) {
                for (let i = 0; i < this.props.subaccounts.list.length; ++i) {
                    if (parseInt(this.state.detailId, 10) === parseInt(this.props.subaccounts.list[i].id)) {
                        this.setState({
                            subaccount: _.clone(this.props.subaccounts.list[i])
                        });
                        break;
                    }
                }
            }
        }

        if (this.props.router.location.pathname.match('new') && this.state.newSubaccount.message === undefined) {
            this.setState({
                newSubaccount: {
                    message: newBoilerplate
                }
            });
        }

        if (prevState.errors === null && this.state.errors !== null) {
            if (this.state.errors.errors !== undefined && this.state.errors.errors.perms !== undefined) {
                let errors = _.clone(this.state.errors);
                this.props.showUpgradeModal(this.props.closeAllModals, null, errors, 'client_limit');
                this.props.deleteApiError(['SUBACCOUNT_CREATE']);
                this.setState({
                    errors: null
                });
            }
        }

        if (prevProps.app.loading.SUBACCOUNT_DETACH === true && this.props.app.loading.SUBACCOUNT_DETACH === false &&
            this.props.getApiErrors(['SUBACCOUNT_DETACH']).length === 0) {
            this.setState({
                detailId: 0,
                subaccount: {},
                lastUpdate: ''
            }, () => {
                this.props.router.navigate('/people/clients');
                this.props.getSubaccounts({
                    accountType: constants.SUB_CLIENT
                });
            });
        }

        if ((prevProps.app.loading.SUBACCOUNT_UPDATE === true && this.props.app.loading.SUBACCOUNT_UPDATE === false) ||
            (prevProps.app.loading.SUBACCOUNT_DELETE === true && this.props.app.loading.SUBACCOUNT_DELETE === false) ||
            (prevProps.app.loading.SUBACCOUNT_CREATE === true && this.props.app.loading.SUBACCOUNT_CREATE === false)) {
            /*
             * An invitation was issued — return to the list view. Keyed on the create
             * request itself rather than on the list growing, because re-inviting an
             * address that already has an outstanding invitation replaces that row
             * instead of adding one.
             */
            if (prevProps.app.loading.SUBACCOUNT_CREATE === true && this.props.app.loading.SUBACCOUNT_CREATE === false &&
                this.props.getApiErrors(['SUBACCOUNT_CREATE']).length === 0 &&
                this.props.router.location.pathname.match('new') !== null) {
                this.props.router.navigate('/people/clients');
                this.props.getUserPerms();
                this.setState({
                    newSubaccount: {}
                });
            } else {
                let resendFailed = this.state.lastUpdate === 'resendInvite' && this.props.getApiErrors(['SUBACCOUNT_UPDATE']).length > 0;
                if (this.state.lastUpdate === 'resendInvite') {
                    makeToast(resendFailed ? "We couldn't resend that invitation." : "Invitation email resent", resendFailed ? "error" : "success");
                }
                this.setState({
                    lastUpdate: '',
                    // a refused resend's note is still to be sent
                    showMessageField: resendFailed
                });
            }

            // check if a user got updated and only rollup the detail if
            // an email has been updated
            if (this.state.detailId !== 0 && this.state.errors === null && this.state.lastUpdate === '') {
                this.setState({
                    detailId: 0,
                    subaccount: {},
                    lastUpdate: ''
                }, () => {
                    this.props.router.navigate('/people/clients');
                });
            }
        }

        /*
         * Invite actions report through a toast, not the detail panel, so they're keyed
         * on their own request finishing and on whether it actually succeeded — the
         * older invite toast fired on the request completing either way.
         */
        if (prevProps.app.loading.SUBACCOUNT_INVITE_RESEND === true && this.props.app.loading.SUBACCOUNT_INVITE_RESEND === false) {
            let resendErrors = this.props.getApiErrors(['SUBACCOUNT_INVITE_RESEND']);
            if (resendErrors.length === 0) {
                makeToast("Invitation email resent", "success");
                // the message just sent is now the invitation's stored note, so close
                // the editor rather than leaving it open over an unchanged draft
                this.setState({
                    showPendingMessage: false
                });
            } else {
                // the send-limit refusal names how long to wait, so prefer the server's
                // own wording over the generic copy when there is one. The editor stays
                // open — the draft is still unsent.
                let refusal = (resendErrors[0].errors && resendErrors[0].errors.validation) ? resendErrors[0].errors.validation.email : '';
                makeToast(refusal || "We couldn't resend that invitation.", "error");
            }
        }

        if (prevProps.app.loading.SUBACCOUNT_INVITE_REVOKE === true && this.props.app.loading.SUBACCOUNT_INVITE_REVOKE === false) {
            if (this.props.getApiErrors(['SUBACCOUNT_INVITE_REVOKE']).length === 0) {
                makeToast("Invitation withdrawn", "success");
                // the row is gone from the list; drop the selection with it
                this.setState({
                    pendingEmail: ''
                });
            } else {
                makeToast("We couldn't withdraw that invitation.", "error");
            }
        }

    }

    createNewSubaccount(e) {
        let constants = this.props.app.config.constants,
            newClient = _.clone(this.state.newSubaccount);

        e.preventDefault();

        this.props.deleteApiError(['SUBACCOUNT_CREATE', 'SUBACCOUNT_UPDATE', 'SUBACCOUNT_DETACH']);
        newClient.accountType = constants.SUB_CLIENT;

        if ((this.state.newSubaccount.organization === undefined || this.state.newSubaccount.organization === '') &&
            this.props.user.detail.organization !== undefined &&
            this.props.user.detail.organization !== '') {
            newClient.organization = this.props.user.detail.organization;
        }

        this.props.createSubaccount(newClient);

    }

    cancel() {

        this.setState({
            detailId: 0,
            pendingEmail: '',
            subaccount: {},
            newSubaccount: {}
        }, () => {
            this.props.router.navigate('/people/clients');
        });

    }

    detailHandler(e) {
        let id = parseInt(e.currentTarget.dataset.id, 10),
            subaccount = {};

        //SubaccountActions.clearMessages('subaccount', id);

        if (id === this.state.detailId) {
            this.setState({
                detailId: 0,
                pendingEmail: '',
                errors: null
            });
            this.props.router.navigate('/people/clients');
            this.props.deleteApiError(['SUBACCOUNT_LIST', 'SUBACCOUNT_UPDATE', 'SUBACCOUNT_CREATE', 'SUBACCOUNT_DETACH']);
        } else {
            for (let i = 0; i < this.props.subaccounts.list.length; ++i) {
                if (parseInt(id, 10) === parseInt(this.props.subaccounts.list[i].id)) {
                    subaccount = _.clone(this.props.subaccounts.list[i]);
                    break;
                }
            }
            this.setState({
                detailId: id,
                pendingEmail: '',
                subaccount
            });
            this.props.router.navigate('/people/clients/detail/' + id);
        }

    }

    /*
     * Selection handler for pending invitations. There is no detail route to navigate
     * to (the account doesn't exist yet), so the expansion is local state only —
     * detailId stays 0 and never identifies a pending row.
     */
    pendingDetailHandler(e) {
        let email = e.currentTarget.dataset.email,
            wasDetail = this.state.detailId !== 0,
            collapsing = (email === this.state.pendingEmail),
            invite = this.props.subaccounts.list.find((sub) => (sub.pending === true && sub.email === email));

        this.setState({
            detailId: 0,
            pendingEmail: (collapsing) ? '' : email,
            // the resend editor starts from the note the invitation already carries,
            // not from the boilerplate — the client has already read this text once
            pendingMessage: (!collapsing && invite) ? (invite.message || '') : '',
            showPendingMessage: false,
            subaccount: {}
        });

        if (wasDetail) {
            this.props.router.navigate('/people/clients');
        }

    }

    togglePendingMessage(e) {
        e.preventDefault();

        this.setState({
            showPendingMessage: !this.state.showPendingMessage
        });

    }

    updatePendingMessage(e) {

        this.setState({
            pendingMessage: e.target.value
        });

    }

    updateSubaccountFields(e) {
        let nextSubaccount = _.clone(this.state.subaccount),
            field = e.currentTarget.dataset.field;

        if (field) {
            nextSubaccount[field] = e.target.value;

            this.setState({
                subaccount: nextSubaccount
            });
        }

    }

    updateSubaccount(e) {
        let nextSubaccount = _.clone(this.state.subaccount),
            field = e.currentTarget.dataset.field;

        e.preventDefault();

        if (nextSubaccount) {
            nextSubaccount[field] = 1;

            this.props.deleteApiError(['SUBACCOUNT_UPDATE', 'SUBACCOUNT_DETACH']);
            this.props.updateSubaccount(nextSubaccount);

            this.setState({
                lastUpdate: field
            });
        }

    }

    setSubaccountActiveState(e) {
        let state = e.currentTarget.dataset.togglestate === "true" ? 0 : 1,
            subaccount = this.state.subaccount;

        //SubaccountActions.clearMessages('subaccount', subaccount.id);

        subaccount.active = state;

        this.props.updateSubaccount(subaccount);

    }

    saveSubaccount(e) {

        let i = 0,
            subaccount = null;

        e.preventDefault();

        //SubaccountActions.clearMessages('subaccount', this.state.detaiId);
        if (!_.isEmpty(this.state.subaccount)) {
            this.setState({
                errors: null
            }, () => {
                this.props.deleteApiError(['SUBACCOUNT_UPDATE', 'SUBACCOUNT_DETACH']);
                // the note is the invitation's, which only a resend changes
                this.props.updateSubaccount(_.omit(this.state.subaccount, 'message'));
            });

        }

    }

    deleteSubaccount(e) {

        this.props.deleteApiError(['SUBACCOUNT_CREATE', 'SUBACCOUNT_UPDATE', 'SUBACCOUNT_DETACH']);

        let cancelDelete = () => {
                this.props.closeAllModals();
            },
            confirmDelete = (e) => {
                e.preventDefault();
                if (this.state.detailId) {
                    //SubaccountActions.clearMessages('subaccount', this.state.detaiId);
                    this.props.detachSubaccount(this.state.detailId);
                }
                this.props.closeAllModals();
            },
            modal = (
                <DeleteModal
                    modalCopy={"Are you sure you want to remove this Client?"}
                    cancelAction={cancelDelete}
                    confirmAction={confirmDelete} />
            );

        e.preventDefault();

        this.props.addModal(modal);

    }

    resendInvite(e) {
        let email = e.currentTarget.dataset.email;

        e.preventDefault();

        this.props.deleteApiError(['SUBACCOUNT_INVITE_RESEND']);
        this.props.resendInvite(email, this.state.pendingMessage);

    }

    revokeInvite(e) {
        let email = e.currentTarget.dataset.email,
            cancelRevoke = () => {
                this.props.closeAllModals();
            },
            confirmRevoke = (event) => {
                event.preventDefault();
                this.props.deleteApiError(['SUBACCOUNT_INVITE_REVOKE']);
                this.props.revokeInvite(email);
                this.props.closeAllModals();
            },
            modal = (
                <DeleteModal
                    modalCopy={"Are you sure you want to withdraw this invitation? The link we emailed will stop working."}
                    cancelAction={cancelRevoke}
                    confirmAction={confirmRevoke} />
            );

        e.preventDefault();

        this.props.addModal(modal);

    }

    searchUsers(e, value) {

        if (value === '') {
            this.props.clearFilter('subaccounts');
        } else {
            this.props.filterStore('subaccounts', ['email', 'clientName'], value);
        }

    }

    toggleMessageField(e) {
        let subaccount = _.clone(this.state.subaccount);

        e.preventDefault();

        // the editor shows the reminder, so the draft starts from it too
        if (!this.state.showMessageField) {
            subaccount.message = resendBoilerplate;
        }

        this.setState({
            showMessageField: !this.state.showMessageField,
            subaccount
        });

    }

    onAddClientClick(e) {
        let nextDetailId = this.state.detailId,
            nextNewSubaccount = this.state.newSubaccount;

        e.preventDefault();

        this.props.deleteApiError(['SUBACCOUNT_CREATE', 'SUBACCOUNT_UPDATE', 'SUBACCOUNT_DETACH']);

        if (this.state.detailId) {
            nextDetailId = 0;
        }

        nextNewSubaccount.message = newBoilerplate;

        this.setState({
            detailId: nextDetailId,
            pendingEmail: '',
            newSubaccount: nextNewSubaccount
        });

    }

    render() {
        let header = null,
            main = null,
            newUserItem = null,
            statusBlock = null,
            newClientName = (this.state.newSubaccount && this.state.newSubaccount.clientName) ? this.state.newSubaccount.clientName : '',
            newEmail = (this.state.newSubaccount && this.state.newSubaccount.email) ? this.state.newSubaccount.email : '',
            organization = (this.state.newSubaccount && this.state.newSubaccount.organization) ? this.state.newSubaccount.organization : '',
            message = (this.state.newSubaccount && this.state.newSubaccount.message) ? this.state.newSubaccount.message : '';

        const clientSocialCount = (clientId) => {
            /* clientPubID */
            let count = 0;

            for (let i = 0; i < this.props.socials.list.length; ++i) {
                if (this.props.socials.list[i].clientPubID === clientId) {
                    ++count;
                }
            }

            return count;
        };

        const hasDisconnectedSocials = (clientId) => {
            for (let i = 0; i < this.props.socials.list.length; ++i) {
                if (this.props.socials.list[i].clientPubID === clientId &&
                    (parseInt(this.props.socials.list[i].sysActionFlag, 10) === 1 || this.props.socials.list[i].activeFlag === 0)) {
                    return true;
                }
            }

            return false;
        }

        const generateStatusBlock = () => {
            if (this.state.errors) {
                return (
                    <div className="detail-status error">
                        <ErrorModule
                            app={this.props.app}
                            keys={['SUBACCOUNT_DETACH']}
                            render={(state) => {
                                return (
                                    <FieldError field="detach" errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SUBACCOUNT_CREATE', 'SUBACCOUNT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="clientName" errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SUBACCOUNT_CREATE', 'SUBACCOUNT_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError
                                        field="email"
                                        errorRE="Publisher already exists."
                                        errorReplacement="That email is already used by another dlvr.it account. Please send your invite to a different email address."
                                        errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SUBACCOUNT_CREATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="organization" errors={state.errors}/>
                                );
                            }}/>
                        <ErrorModule
                            app={this.props.app}
                            keys={['SUBACCOUNT_CREATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="message" errors={state.errors}/>
                                );
                            }}/>
                    </div>
                );
            }

            return null;
        };

        if (this.props.user.detail.isAgent) {
            let acctMessage = <EmptyState message={"Sorry, only the account owner can access this page."}/>;
            return (
                <Content header={header} main={acctMessage}/>
            );
        }

        if (parseInt(this.props.user.perms.perms.clientSeats, 10) === 0) {
            main = (
                <FeatureUpgradeComponent
                    {...this.props}
                    context="clients"
                    showCTA={false}/>
            );
            return (
                <Content header={header} main={main}/>
            );
        }

        header = (
            <SubaccountHeader
                hostPage="clients"
                {...this.props}
                searchHandler={this.searchUsers}
                recordPath={this.props.recordPath}
                user={this.props.user}
                newSubaccountCallback={this.onAddClientClick} />
        );



        if (this.props.router.location.pathname.match('new')) {
            let orgField = null;

            if (this.props.user.detail.organization !== undefined && this.props.user.detail.organization === '') {
                orgField = (
                    <fieldset>
                        <legend>Your Organization <span className="required">*</span></legend>
                        <UncontrolledTextInput className="text-input large" placeholder="Agency name" defaultValue={organization} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="newSubaccount.organization"/>
                    </fieldset>
                );
            }

            newUserItem = (
                <li key="new" className="dlvr-list-item simple detail">
                    <div className="list-item-display">
                        <div className="item-type-icon">
                            <i className="fa fa-user new-subaccount"></i>
                        </div>
                        <div className="item-name client">
                            {'New Client'}
                        </div>
                        <div className="item-email client">
                            {(newEmail) ? newEmail : ''}
                        </div>
                    </div>
                    <div className="new-shortener-detail">
                        {generateStatusBlock()}
                        <div className="column-container">
                            <form>
                                <div className="editor-panel short">
                                    <fieldset>
                                        <legend>Client name <span className="required">*</span></legend>
                                        <UncontrolledTextInput className="text-input large" placeholder="Client name" defaultValue={newClientName} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="newSubaccount.clientName" />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Client email <span className="required">*</span></legend>
                                        <UncontrolledTextInput className="text-input large" placeholder="Client email" defaultValue={newEmail} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="newSubaccount.email" />
                                    </fieldset>
                                    {orgField}
                                    <fieldset>
                                        <legend>Message</legend>
                                        <UncontrolledTextInput className="text-area large" isTextArea={true} defaultValue={newBoilerplate} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="newSubaccount.message"/>
                                    </fieldset>
                                </div>
                            </form>
                            <div className="explainer-wrapper">
                                <div className="explainer">
                                    <div className="headline">Invite Client</div>
                                    <div className="copy">We'll send your client an invitation to link their social profiles to this dlvr.it account.</div>
                                </div>
                            </div>
                        </div>
                        <div className="form-buttons standalone">
                            <div className="cancel-button" onClick={this.cancel} role="button" aria-label="cancel">cancel</div>
                            <button className="btn-primary active fixed" onClick={this.createNewSubaccount}>
                                Invite
                            </button>
                        </div>
                    </div>
                </li>
            );
        }

        main = (
            <ul className="dlvr-list-component">
                {newUserItem}
                {this._getSubaccounts().map(function(subaccount, i) {
                    // An outstanding invitation has no account behind it yet: no id, no
                    // login, no socials. Everything below branches on that rather than on
                    // id/lastLogin, each of which reads as a live value — and an id of 0
                    // would count the parent's own unassigned socials as the client's.
                    let pending = subaccount.pending === true,
                        isDetail = pending
                            ? (subaccount.email === this.state.pendingEmail)
                            : (subaccount.id === this.state.detailId),
                        hasSelection = (this.state.detailId !== 0 || this.state.pendingEmail !== ''),
                        itemClass = classnames(
            				'dlvr-list-item',
            				{
                                'pending': pending,
            					'detail': isDetail,
            					'blur': (hasSelection && !isDetail)
            				}
                        ),
                        itemNameClass = classnames(
                            'item-name', 'client'
                        ),
                        itemEmailClass = classnames(
                            'item-email', 'client'
                        ),
                        statusClass = classnames(
                            "route-status", "common",
                            {
                                'active': (!pending && clientSocialCount(subaccount.id) && !hasDisconnectedSocials(subaccount.id)),
                                'error': (!pending && hasDisconnectedSocials(subaccount.id)),
                                'pending': pending
                            }
                        ),
                        statusIcon = null,
                        itemDetail = null,
                        lastLogin = new Date(subaccount.lastLogin),
                        inviteExpires = (pending && parseInt(subaccount.expiration, 10)) ? new Date(parseInt(subaccount.expiration, 10) * 1000) : null,
                        userActive = (parseInt(subaccount.active, 10) === 2) ? false : true,
                        subaccountIconClass = classnames(
                            'fa', 'fa-briefcase', 'subaccount',
                            {
                                'pending': pending
                            }
                        ),
                        clientName = (this.state.subaccount && this.state.subaccount.clientName) ? this.state.subaccount.clientName : '',
                        subaccountEmail = (this.state.subaccount && this.state.subaccount.email) ? this.state.subaccount.email : '',
                        messageButton = null,
                        messageFieldset = null,
                        emailField = null;

                    // pending rows get their own panel below; none of these fields apply
                    if (!pending) {
                        if (_.isNaN(lastLogin.getTime())) {
                            emailField = (
                                <fieldset>
                                    <legend>Client Email <span className="required">*</span></legend>
                                    <UncontrolledTextInput className="text-input medium" defaultValue={subaccountEmail} onChange={this.updateSubaccountFields} data-field="email"/>
                                    {messageButton}
                                </fieldset>
                            );
                            if (!this.state.showMessageField) {
                                messageButton = (
                                    <div style={{margin: '40px 0'}}>
                                        <button className="btn-secondary fixed" onClick={this.toggleMessageField} data-field="resendInvite">
                                            Resend Invite Email
                                        </button>
                                    </div>
                                );
                            } else {
                                messageFieldset = (
                                    <fieldset>
                                        <legend>Message</legend>
                                        <UncontrolledTextInput className="text-area medium" style={{height: '150px'}} isTextArea={true} defaultValue={resendBoilerplate} onChange={FormUtilityMixin.requestChange.bind(this)} data-field="subaccount.message"/>
                                        <div style={{width: '52%', textAlign: 'right'}}>
                                            <button className="btn-primary reverse-fixed" style={{margin: '20px 0 20px 0'}} onClick={this.updateSubaccount} data-field="resendInvite">
                                                Send
                                            </button>
                                        </div>
                                    </fieldset>
                                );

                            }
                        } else {
                            emailField = (
                                <fieldset>
                                    <legend>Client Email</legend>
                                    <span>{subaccountEmail}</span>
                                </fieldset>
                            );
                        }
                    }

                    let socialCount = (pending) ? 0 : clientSocialCount(subaccount.id),
                        label = (socialCount === 1) ? 'social' : 'socials',
                        link = (socialCount > 0) ? true : false;

                    if (pending) {
                        statusIcon = (
                            <div className="route-status-icon">
                                <i className="fa fa-clock-o"/>
                            </div>
                        );
                    } else if (socialCount > 0 && !hasDisconnectedSocials(subaccount.id)) {
                        statusIcon = (
                            <div className="route-status-icon">
                                <i className="fa fa-check-circle"/>
                            </div>
                        );
                    }  else if (socialCount === 0) {
                        statusIcon = (
                            <div className="route-status-icon">
                                <i className="fa fa-dot-circle-o"/>
                            </div>
                        );
                    } else {
                        statusIcon = (
                            <div className="route-status-icon">
                                <i className="fa fa-exclamation-circle error"/>
                            </div>
                        );
                    }

                    if (isDetail && pending) {
                        // Nothing here can address a Publisher row, so the panel offers
                        // only the two things that act on the invitation itself.
                        statusBlock = (
                            <div className="detail-status inactive">
                                {(inviteExpires) ? (
                                    <span>Client hasn't accepted invite — expires <FormattedDate
                                                                                    value={inviteExpires}
                                                                                    day="numeric"
                                                                                    month="long"
                                                                                    year="numeric"/></span>
                                ) : (
                                    <span>Client hasn't accepted invite.</span>
                                )}
                            </div>
                        );
                        itemDetail = (
                            <div>
                                <Breakpoint desktop only>
                                    <div className="detail-controls">
                                        <div className="detail-buttons">
                                            <div className="detail-button" onClick={this.revokeInvite} data-email={subaccount.email} role="button" aria-label="withdraw invitation">
                                                <div className="button-icon">
                                                    <i className="fa fa-remove"></i>
                                                </div>
                                                <div className="button-label">
                                                    Revoke
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Breakpoint>
                                <Breakpoint mobile only>
                                    <div className="detail-controls mobile">
                                        <div className="detail-control-row">
                                            <div className="detail-button" onClick={this.revokeInvite} data-email={subaccount.email} role="button" aria-label="withdraw invitation">
                                                <div className="button-icon">
                                                    <i className="fa fa-remove"></i>
                                                </div>
                                                <div className="button-label">
                                                    Revoke
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Breakpoint>
                                {statusBlock}
                                <div className="editor-panel short">
                                    <div className="column-container">
                                        <fieldset>
                                            <legend>Client Name</legend>
                                            <span>{subaccount.clientName}</span>
                                        </fieldset>
                                        <fieldset>
                                            <legend>Client Email</legend>
                                            <span>{subaccount.email}</span>
                                            {(this.state.showPendingMessage) ? null : (
                                                <div style={{margin: '40px 0'}}>
                                                    <button className="btn-secondary fixed" onClick={this.togglePendingMessage}>
                                                        Resend Invitation
                                                    </button>
                                                </div>
                                            )}
                                        </fieldset>
                                        {(this.state.showPendingMessage) ? (
                                            <fieldset>
                                                <legend>Message</legend>
                                                <UncontrolledTextInput className="text-area medium" style={{height: '150px'}} isTextArea={true} defaultValue={this.state.pendingMessage} onChange={this.updatePendingMessage} data-field="pendingMessage"/>
                                                <div style={{width: '52%', textAlign: 'right'}}>
                                                    <button className="btn-primary reverse-fixed" style={{margin: '20px 0 20px 0'}} onClick={this.resendInvite} data-email={subaccount.email}>
                                                        Send
                                                    </button>
                                                </div>
                                            </fieldset>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        )
                    } else if (isDetail) {
                        statusBlock = generateStatusBlock();
                        if (statusBlock === null && _.isNaN(lastLogin.getTime()) && parseInt(subaccount.active, 10)) {
                            statusBlock = (
                                <div className="detail-status inactive">
                                    Client hasn't accepted invite.
                                </div>
                            );
                        }
                        itemDetail = (
                            <div>
                                <Breakpoint desktop only>
                                    <div className="detail-controls">
                                        <div className="detail-toggle">

                                        </div>
                                        <div className="detail-buttons">
                                            <div className="detail-button" onClick={this.deleteSubaccount} data-id={subaccount.id} role="button" aria-label="remove client">
                                                <div className="button-icon">
                                                    <i className="fa fa-remove"></i>
                                                </div>
                                                <div className="button-label">
                                                    Remove
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Breakpoint>
                                <Breakpoint mobile only>
                                    <div className="detail-controls mobile">
                                        <div className="detail-control-row">
                                            <div className="detail-button" onClick={this.deleteSubaccount} data-id={subaccount.id} role="button" aria-label="remove client">
                                                <div className="button-icon">
                                                    <i className="fa fa-remove"></i>
                                                </div>
                                                <div className="button-label">
                                                    Remove
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Breakpoint>
                                {statusBlock}
                                <div className="editor-panel short">
                                    <div className="column-container">
                                        <fieldset>
                                            <legend>Client Name</legend>
                                            <UncontrolledTextInput className="text-input medium" defaultValue={clientName} onChange={this.updateSubaccountFields} data-field="clientName"/>
                                        </fieldset>
                                        {emailField}
                                        {messageButton}
                                        {messageFieldset}
                                        </div>
                                    <fieldset>
                                        <div className="form-buttons">
                                            <div className="cancel-button" onClick={this.cancel} role="button" aria-label="cancel">cancel</div>
                                            <button className="btn-primary active fixed" onClick={this.saveSubaccount}>
                                                Save
                                            </button>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        )
                    }

                    return (
                        <li key={i} className={itemClass}>
                            <div className="list-item-display"
                                onClick={(pending) ? this.pendingDetailHandler : this.detailHandler}
                                data-id={subaccount.id}
                                data-email={subaccount.email}
                                role="switch"
                                aria-label="show detail">
                                <div className="item-type-icon">
                                    <i className={subaccountIconClass}></i>
                                </div>
                                <div className={itemNameClass}>
                                    {subaccount.clientName}
                                </div>
                                <div className={itemEmailClass}>
                                    {subaccount.email}
                                </div>
                                <div className={statusClass}>
                                    <span className="route-status-label social-count">
                                        {(pending) ? 'Invitation pending' : ((link) ? (<Link to={"/config/socials?client=" + subaccount.id} onClick={(e) => { e.stopPropagation(); }}>{socialCount} {label}</Link>) : (socialCount + " " +label))}
                                    </span>
                                    {statusIcon}
                                </div>
                            </div>
                            {itemDetail}
                        </li>
                    );
                }, this)}
            </ul>
        );

        return (
            <Content header={header} main={main} />
        );
    }

}

Clients.displayName = "Clients";

const enhance = compose(
    ComponentWithContext,
    SubaccountProvider
);

export default enhance(Clients);
